module.exports = __webpack_public_path__ + "way2go/static/config/gmc_restrictions_legend.png";